import japan from '../../assets/japan.svg';
import korea from '../../assets/korea.svg';

export const footerData: { title: string, icon: string }[] = [
  { title: 'Japan Flag', icon: japan },
  { title: 'Korean Flag', icon: korea },
];
